import { useCallback } from 'react';
import { MOVABLE_INK_GET_CAMPAIGNS } from 'api/MovableInkIntegrationsAPI';
import { useRestMutation } from 'utils/hooks/api';
import { MovableInkCampaign } from '../types';

type MovableInkCampaignsRequest = {
  tokenId: number;
} & Partial<{
  search: string;
  page: number;
  perPage: number;
  sortBy: string;
  order: string;
  companyId: number;
}>;

type MovableInkCampaignsResponse = {
  campaigns: MovableInkCampaign[];
  totalPages: number;
};

export const useMovableInkCampaignsMutation = () => {
  const {
    data: { campaigns = [], totalPages = 0 } = {},
    isLoading,
    isError,
    isSuccess,
    mutate,
  } = useRestMutation<MovableInkCampaignsResponse, MovableInkCampaignsRequest>(
    MOVABLE_INK_GET_CAMPAIGNS,
  );

  const refetchCampaignsByTokenId = useCallback(
    ({ tokenId, companyId }: Partial<{ tokenId: number; companyId: number }>) => {
      if (tokenId && companyId) mutate({ tokenId, companyId });
    },
    [mutate],
  );

  return {
    campaigns,
    totalPages,
    isLoading,
    isError,
    isSuccess,
    refetchCampaignsByTokenId,
  };
};
